<template>
  <div>
    <mobile-menu-group
      v-for="(group, index) in groups"
      :id="group.TabIdName"
      :key="index"
      :class="{'mt-base': index > 0}"
      :header-text="group.headerText"
      :items="group.items"/>
  </div>
</template>

<script>
import MobileMenuGroup from '@/views/modules/_components/MobileMenuGroup.vue';

/**
 * User account menu
 *
 * @module views/modules/user-account/UserAccountMenu
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {Object[]} [groups=[...]] - groups to show in the menu
 * @vue-event {void} logout - logout
 */
export default {
  name: 'UserAccountMenu',
  i18n: {
    messages: {
      en: {
        AccountDetailsText: 'Manage your account details',
        BrandingText: 'Manage your branding colours',
        CompanyPoliciesText: 'Manage your company policies',
        OpeningHoursText: 'Manage your business opening hours',
        SecurityText: 'Keep your account safe with security recommendations',
      },
    },
  },
  components: {
    MobileMenuGroup,
  },
  data() {
    return {
      groups: [
        {
          headerText: '',
          TabIdName: 'mobile-group-account',
          items: [
            {
              title: this.$t('$UserSettings.$Account.$AccountDetails.TabTitle'),
              text: this.$t('AccountDetailsText'),
              icon: 'UserIcon',
              path: '/account-mobile/details',
            },
            {
              title: this.$t('$UserSettings.$Account.$Branding.TabTitle'),
              text: this.$t('BrandingText'),
              icon: 'BoldIcon',
              path: '/account-mobile/branding',
            },
            {
              title: this.$t('$UserSettings.$Account.$CompanyPolicies.TabTitle'),
              text: this.$t('CompanyPoliciesText'),
              icon: 'FileIcon',
              path: '/account-mobile/policies',
            },
            {
              title: this.$t('$UserSettings.$Account.$OpeningHours.TabTitle'),
              text: this.$t('OpeningHoursText'),
              icon: 'ClockIcon',
              path: '/account-mobile/opening-hours',
            },
            {
              title: this.$t('$UserSettings.$Account.$Security.TabTitle'),
              text: this.$t('SecurityText'),
              icon: 'ShieldIcon',
              path: '/account-mobile/security',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.disabled-menu-item {
  opacity: 0.5;
  cursor: not-allowed;
  
  &:hover {
    opacity: 0.5;
  }
}
</style>
